import { atQuery } from '../components/mediaQueries';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCarouselBanner = (context) => {
  if (!context || context.querySelectorAll('.swiper-slide').length <= 0) return;

  const maxSlides = 12;
  const slides = context.querySelectorAll('.swiper-slide');

  if (slides.length > maxSlides) {
    slides.forEach((slide, index) => {
      if (index >= maxSlides) {
        slide.remove();
      }
    });
  }

  let initialSlideIndex = 0;
  atQuery('min', 'md', () => {
    initialSlideIndex = Math.floor(Math.min(slides.length, maxSlides) / 2);
  });

  const swp = new Swiper(context, {
    freeMode: false,
    slidesPerView: 2,
    spaceBetween: 8,
    initialSlide: initialSlideIndex,
    allowTouchMove: true,
    breakpoints: {
      769: {
        slidesPerView: '3',
        spaceBetween: 8,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
    },
    pagination: {
      el: context.querySelector('.carousel-banner__pagination'),
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true
    },
  });

  swp.update();

  setTimeout(() => {
    swp.slideTo(initialSlideIndex, 0, false);
  }, 0);
};

if (document.readyState != 'loading') {
  [].forEach.call(
    document.querySelectorAll('.carousel-banner__container'),
    (el) => {
      window.dAgency.initCarouselBanner(el);
    },
  );
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(
      document.querySelectorAll('.carousel-banner__container'),
      (el) => {
        window.dAgency.initCarouselBanner(el);
      },
    );
  });
}
